import { useEffect } from 'react';

const BUTTON = 'rounded-lg border border-(--color-line) px-3.5 py-2 text-body transition hover:bg-(--color-sunken)';
const PRIMARY = 'rounded-lg bg-(--color-brand) px-4 py-2 text-body font-medium text-(--color-brand-ink) transition hover:bg-(--color-brand-strong)';

/**
 * A yes-or-no in front of something that cannot be undone.
 *
 * Not `window.confirm`, for the same reasons NameAFlow is not `window.prompt`: it
 * cannot be styled, it blocks the page, and it says "localhost says" in front of the
 * product.
 */
export function Confirm({ title, body, confirm, danger, onCancel, onConfirm }: {
  title: string; body: string; confirm: string; danger?: boolean; onCancel: () => void; onConfirm: () => void;
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onCancel(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onCancel]);

  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-black/40 p-4" onClick={onCancel}>
      <div role="dialog" aria-modal="true" aria-label={title} onClick={(e) => e.stopPropagation()} className="w-full max-w-sm rounded-xl bg-(--color-surface) p-5 shadow-(--shadow-lift)">
        <h2 className="text-lead font-semibold">{title}</h2>
        <p className="mt-1.5 text-body text-(--color-ink-soft)">{body}</p>
        <div className="mt-4 flex justify-end gap-2">
          <button type="button" onClick={onCancel} className={BUTTON}>Cancel</button>
          <button type="button" onClick={onConfirm} className={danger ? 'rounded-lg bg-(--color-bad) px-4 py-2 text-body font-medium text-white' : PRIMARY} autoFocus>
            {confirm}
          </button>
        </div>
      </div>
    </div>
  );
}

